module.exports = __webpack_public_path__ + "img/21-2.2ddb655f.jpg";